import { components } from "react-select";
import AsyncSelect from 'react-select/async';
import classNames from 'classnames';
import styled from "styled-components";
import Checkbox from "../../FormFields/Checkbox";
import Icon from "../Icon";
import { ReactComponent as CloseIcon } from "/img/widget-remove-list-li.svg";
import Utils from '../../../Services/Utils'
import { useState, useEffect } from "react";
import TagsService from '../../../Services/api/TagsService';

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <Checkbox checked={props.isSelected} label={props.label} onChange={() => null} istag="true" />
      </components.Option>
    </div>
  );
};

const customStyles = (isShowValuesContainer) => {
  return {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: '#FFFFFF',
      color: '#2A394E'
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: 0,
    }),
    multiValue: (base) => {
      return ({
        ...base,
        display: isShowValuesContainer ? `none` : `flex`,
      });
    }
  }
}

const ValuesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const Value = styled.div`
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  margin: 0 0.55rem 0.55rem 0;
  font-size: 0.7em;
  color: #FFFFFF;
  background-color: rgb(40, 149, 241);
  user-select: none;
`;

const XButton = styled.button`
  all: unset;
  margin-left: 8px;
  color: #ffffff;
  transition: fill 0.15s ease-in-out;
  cursor: pointer;
`;

const TagSelect = (props) => {
  const { isMulti, value, onValueChange, showValuesContainer, availableTags, isAdmin } = props;
  const [open, setOpen] = useState();
  const [selectedValue, setSelectedValue] = useState([]);
  let tagTypeOptions = availableTags;

  const getAvailableTags = async (searchText, TagIds) => {
    let tagsparams = isAdmin ? { ordering: 'tag_name' } : { ordering: 'display_name' };
    if (searchText) {
      tagsparams['search'] = searchText;
    }
    if (TagIds && TagIds.length > 0) {
      tagsparams['tag_id'] = JSON.stringify(TagIds);
    }
    return await TagsService.list(tagsparams);
  };

  useEffect(() => {
    if (!Utils.isNull(value)) {
        let selectedValueArr = [];
        
        // Start Section for Unavailable Tags: To find the same

              let unAvailableTagIds = [];
              if (tagTypeOptions && tagTypeOptions.length > 0) {
                value && value.forEach((valobj) => {
                  let isExist = false;
                  let val = valobj.value || valobj;
                  tagTypeOptions.forEach((avTag) => {
                    if (val == avTag.value) {
                      isExist = true;
                      selectedValueArr.push(avTag);
                    }
                  });
                  if (!isExist) {
                    unAvailableTagIds.push(val);
                  }
                });
              }
              if (unAvailableTagIds.length > 0) {
                let tagIds = [];
                tagIds = unAvailableTagIds.map((tg)=>{
                  return tg.value || tg;
                });
                getAvailableTags('', tagIds).then((selectedTagsData) => {
                  selectedTagsData && selectedTagsData.forEach((item) => {
                    if (item.allow_use_in_dynamic_forms) {
                      tagTypeOptions.push({ value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
                      selectedValueArr.push({ value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
                    }
                  });
                  setSelectedValue(selectedValueArr);
                });
              }
              else {
                setSelectedValue(selectedValueArr);
              }

        // End Unavailable Tags section
    }
  }, []);

  let searchTimeout;
  const promiseOptions = (inputValue) => {
      return new Promise((resolve) => {
        let searchedTags = [];
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          if(inputValue) {
            getAvailableTags(inputValue, true).then((filteredTags) => {
              if (filteredTags && filteredTags.length > 0) {
                filteredTags.forEach((item) => {
                  if (item.allow_use_in_dynamic_forms) {
                    let isExist = false;
                    searchedTags.push({value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
                    tagTypeOptions && tagTypeOptions.forEach((avTag) => {
                      if (item.id == avTag.value) {
                        isExist = true;
                      }
                    })
                    if(tagTypeOptions && !isExist) {
                      tagTypeOptions.push({value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
                    }
                  }
                  if (!item.allow_use_in_dynamic_forms) {
                    if (selectedValue && selectedValue.length > 0) {
                      useEffect(()=> {
                        setSelectedValue(selectedValue.filter(sItem => sItem.value !== item.id));
                      }, []);
                    }
                  }
                });
              }
              setTimeout(() => {
                resolve(searchedTags);
              }, 500);
            });
          }
          else {
            resolve(tagTypeOptions);
          }
        }, 800);
      });
  }

  const handleRemoveValue = (e) => {
    e.preventDefault();
    if (!onValueChange) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = selectedValue.filter((val) => val.value.toString() === buttonName);
    if (!removedValue) return;
    let remainingValues = selectedValue.filter(sItem => sItem.value.toString() !== buttonName)
    setSelectedValue(remainingValues);
    onValueChange(remainingValues);
  };

  const handleOutsideClicks = (event) => {
    setOpen(false);
    document.removeEventListener('mousedown', handleOutsideClicks);
  };

  const onMenuOpen = () => {
    setOpen(true);
    document.addEventListener("mousedown", handleOutsideClicks);
  }

  const onMenuClose = () => {
    setOpen(false)
    document.removeEventListener('mousedown', handleOutsideClicks);
  }

  // handle selection
  const handleChange = value => {
    setSelectedValue(value);
    if (!onValueChange) return;
    onValueChange(value);
  }

  return (
    <div className="margin_bottom">
      <AsyncSelect
        isMulti={isMulti}
        maxMenuHeight={200} className={classNames('Select')} styles={customStyles(showValuesContainer)}
        cacheOptions
        defaultOptions
        value={selectedValue}
        components={{ Option }}
        getOptionLabel={e => e.label}
        getOptionValue={e => e.value}
        loadOptions={promiseOptions}
        onChange={handleChange}
        closeMenuOnSelect={false}
        blurInputOnSelect={false} hideSelectedOptions={false} onMenuOpen={onMenuOpen} onMenuClose={onMenuClose}
        menuIsOpen={open}
      />

    {showValuesContainer && <ValuesContainer>
        {selectedValue && selectedValue.length > 0 ? selectedValue.map((val) => (
          <Value key={val.value}>
            {val.label}
            <XButton name={val.value} onClick={handleRemoveValue}>
              <Icon className="Inline_Clone" width='5' height='5'>
                <CloseIcon alt='expand-closed' />
              </Icon>
            </XButton>
          </Value>
        ))
          : null}
      </ValuesContainer>}
    </div>
  );
};

export default TagSelect;
